module.exports = __webpack_public_path__ + "static/media/trail_marker.e3c4ca32.svg";